import styled from 'styled-components';

export const RowsContainer = styled.div`
  width: 100%;
  margin: 25px 30px 5px 30px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  margin-bottom: 20px;
`;

export const RowTitle = styled.div`
  flex-grow: 1;
  font-size: 14px;
  color: #000;
  ${({ bold, theme }) => bold && `font-family: ${theme.fontBold}`};
`;
